import script from "./DrivetrainLegend.vue?vue&type=script&setup=true&lang=js"
export * from "./DrivetrainLegend.vue?vue&type=script&setup=true&lang=js"

import "./DrivetrainLegend.vue?vue&type=style&index=0&id=1b89dbae&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1b89dbae"]])

export default __exports__